import moment from "moment";
import momentTz from "moment-timezone";

import Colors from "../Constants/Colors";

export const stringWidth = (str) => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  context.font = "14px Poppins";
  return context.measureText(str).width + 2;
};

export const taskTitleValidation = (title) => {
  if (title.length < 2) return "Minimum 2 characters required.";
  if (title.length > 50) return "Maximum 50 characters allowed.";

  return false;
};

export const capitalizeWords = (str) => {
  if (!str) return "";
  return str
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export const ICON_STYLE = {
  color: Colors.lightGrey,
  border: `1px solid ${Colors.borderInput}`,
  borderRadius: "6px",
  cursor: "pointer",
  "&:hover": {
    border: `1px solid ${Colors.primary}`,
  },
};

export const formattedTags = (tags) => {
  return [...new Set(tags[0].tags)]
    .map((tag) => tag.replace(tag[0], tag[0].toUpperCase()))
    .join(", ");
};

export const INVOICED_ACTIVITY_ICON_STYLE = (isInvoiced) => {
  return {
    border: `1px solid ${isInvoiced ? Colors.success : Colors.borderInput}`,
    borderRadius: "6px",
    padding: "2px",
    color: isInvoiced ? Colors.success : Colors.lightGrey,
  };
};

export const uniqueList = (...arr) => {
  try {
    if (!(arr instanceof Array)) {
      throw new Error("Invalid argument passed");
    }

    const areStrings = arr.every(item => typeof item === 'string');

    if (!areStrings) {
      console.error(new Error("Only array of strings allowed"));
      return [];
    }

    if (!arr.length) return [];

    return [...new Set(arr)].filter(item => item).sort((a, b) => a.localeCompare(b));
  } catch (err) {
    console.error(err);
  }
};

export const isPaidUser = (user) => {
  if (!user || !user.plan) return false;

  switch (user.plan) {
    case "free":
      return false;

    case "pro": {
      const isPlanExpired =
        moment(user.planExpiresAt).toDate() < moment().toDate();

      return !isPlanExpired;
    }

    case "premium":
      return true;

    default:
      return false;
  }
};

export const copyToClipboard = async (value) => {
  await navigator.clipboard.writeText(value);
};

export const shareOnEmail = (meeting) => {
  const subject = encodeURIComponent(
    `Google Meet Link for Your Meeting with ${meeting.organizer.name}`
  );

  const body = encodeURIComponent(
    `Hi,

Please join the Google Meet using the link below at the scheduled time:

Meeting Details:
    
Date: ${moment(meeting.scheduledAt).format('LL')}
Time: ${moment(meeting.scheduledAt).format("hh:mm A")} - ${moment(meeting.scheduledAt).add(meeting.duration, "minutes").format("hh:mm A")}
Meeting Link: ${meeting.conferenceLink}

Looking forward to speaking with you.
    
Best Regards,
${meeting.organizer.name}`,
  );

  const mailtoLink = `mailto:?subject=${subject}&body=${body}`;

  window.open(mailtoLink, "_blank", "noopener,noreferrer");
};

export const shareOnWhatsapp = (conferenceLink) => {
  const message = `Hi,\n\nPlease join the Google Meet using the link below at the scheduled time:\nGoogle Meet: ${conferenceLink}`;

  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;

  window.open(whatsappUrl, "_blank", "noopener,noreferrer");
};

export const shareOnReddit = (conferenceLink) => {
  const title = "Join the Google Meet for Discussion";

  const redditUrl = `https://www.reddit.com/submit?url=${encodeURIComponent(
    conferenceLink
  )}&title=${encodeURIComponent(title)}`;

  window.open(redditUrl, "_blank", "noopener,noreferrer");
};

function getIANATimezonesWithOffset() {
  const timezones = momentTz.tz.names();

  const now = new Date();

  return timezones.map((tz) => {
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: tz,
      hour12: false,
      timeZoneName: "shortOffset",
    });

    const parts = formatter.formatToParts(now);
    const offsetPart = parts.find((p) => p.type === "timeZoneName");

    return {
      iana: tz,
      timezone: (offsetPart && offsetPart.value.replace("GMT", "")) || "UTC",
    };
  });
}
export const timezoneList = getIANATimezonesWithOffset();

export const WEEK_DAYS = [
  { key: "sun" },
  { key: "mon" },
  { key: "tue" },
  { key: "wed" },
  { key: "thu" },
  { key: "fri" },
  { key: "sat" },
];

export const DEFAULT_WORKING_HOURS = [{ start: "10:00", end: "18:00" }];

export const addOneHour = (time) => {
  const [h, m] = time.split(":").map(Number);
  const nextHour = (h + 1) % 24;
  return `${nextHour.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}`;
};

export const formatToAmPm = (time) => {
  return moment(time, "HH:mm").format("hh:mm A");
};
